import LinkOff from '@mui/icons-material/LinkOff'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import type { Entity } from '@models/Entity'

import type { UnauthorizedProject } from '../../../aansluiting/project/types/UnauthorizedProject'
import type { UnauthorizedHoofdleidingProject } from '../../../hoofdleiding/project/types/UnauthorizedHoofdleidingProject'
import { StyledIconButton } from '../../../theme/components/StyledIconButton'
import type { Styles } from '../../../theme/types/Styles'

export { UnauthorizedLinkedProjectRow }

const USED_CELLS = 2

type Props = {
  entity: Entity
  colSpan: number
  project: UnauthorizedProject | UnauthorizedHoofdleidingProject
  canUnlink?: boolean
  openUnlinkDialog: (id: string) => void
  sx?: Styles
}

const UnauthorizedLinkedProjectRow = ({
  entity,
  colSpan,
  project,
  openUnlinkDialog,
  canUnlink,
  sx = {},
}: Props) => {
  return (
    <TableRow sx={sx}>
      <TableCell>
        {project.aanvraagID}

        {'naam' in project && (
          <>
            <br />
            <Typography variant="caption">{project.naam}</Typography>
          </>
        )}
      </TableCell>
      <TableCell colSpan={colSpan - USED_CELLS}></TableCell>

      <TableCell>
        {canUnlink && (
          <StyledIconButton
            icon={<LinkOff />}
            title={`Ontkoppel project ${project.aanvraagID} van ${entity.id}`}
            onClick={() => openUnlinkDialog(project.aanvraagID)}
          />
        )}
      </TableCell>
    </TableRow>
  )
}
